import React from 'react'
import { validators } from '../../utils/helpers/validators'
import SaveButton from '../common/buttons/SaveButton'
import LabeledText from '../common/form-components/labeled-inputs/LabeledText'
import './roles-form.scss'

const RolesForm = ({ inputs, handleChange, handleSubmit }) => {
  const validateForm = validators.hasValue(inputs?.role)

  return (
    <div className="roles-form-container">
      <div className="modal-content-wrapper">
        <LabeledText
          idLabel="name"
          required
          name="role"
          value={inputs?.role}
          type="text"
          onChange={(e) => handleChange(e)}
        />
      </div>
      <div className="modal-btn-container">
        <SaveButton
          btnClass="btn-save-modal"
          onClick={() => handleSubmit()}
          isDisabled={!validateForm}
        />
      </div>
    </div>
  )
}

export default RolesForm
